import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '01',
  title: '20 Geheimstationen',
  desc: 'Die Stationen, die Einheimische als ihr bestes Geheimnis hüten. Schritt-für-Schritt-Guides für Wallis, Bern, Graubünden, Jura und Tessin. Pässe ab 25 CHF.'
}, {
  icon: '02',
  title: 'Transport unter 15 CHF',
  desc: "Günstige SBB-Tickets, die 90% der Fahrer nicht kennen. Halbtax, Saver Day Pass und Snow'n'Rail — vollständig erklärt."
}, {
  icon: '03',
  title: 'GPS-Kompass & Insider-Karten',
  desc: 'Kein Suchen mehr. Exakte Koordinaten für kostenlose Parkplätze und geheime Gondel-Zugänge.'
}, {
  icon: '04',
  title: 'Swiss Peak Zertifikat',
  desc: 'Methodik der Exzellenz. Ein System, das bestätigt, dass Sie die Alpen wirklich kennen.'
}];
export function Benefits() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-21">
      <div className="max-w-xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-23">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-24">
            Was Sie erhalten
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-25">
            Alles, was Sie brauchen, um die Alpen ohne Stress zu beherrschen.
            <br data-id="element-26" />
            Vier Säulen, die Ihren Winter für immer verändern werden.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 mb-6" data-id="element-27">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-brand-orange/20 p-5 rounded-2xl hover:border-brand-orange/50 transition-colors" data-id="element-28">
              <div className="flex items-start gap-3" data-id="element-29">
                <div className="text-brand-orange font-black text-lg tracking-widest shrink-0 mt-0.5" data-id="element-30">
                  · {b.icon} ·
                </div>
                <div data-id="element-31">
                  <h3 className="text-lg font-bold text-brand-gold mb-1" data-id="element-32">
                    {b.title}
                  </h3>
                  <p className="text-gray-300 text-sm font-medium leading-snug" data-id="element-33">
                    {b.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}